import { getFID, getLCP } from 'web-vitals';

import dataLayer from '@rover/globals/dataLayer';
import LOCAL_STORAGE_KEYS from '@rover/shared/js/constants/localStorage.constants';
import trackCumulativeLayoutShift from '@rover/utilities/trackCumulativeLayoutShift';

const fireInputDependentPerformanceEvent = async () => {
  const metrics = await Promise.all([
    new Promise((res) => getFID(({ value }) => res(value))),
    new Promise((res) => getLCP(({ value }) => res(value))),
  ]);

  const performanceEvent = {
    event: 'input-dependent-performance',
    firstInputDelay: metrics[0] || 0,
    largestContentfulPaint: metrics[1] || 0,
  };

  dataLayer.push(performanceEvent);
};

window.addEventListener('load', () => fireInputDependentPerformanceEvent());

const fireCumulativeLayoutShiftEvent = async () => {
  const storedClsEvent = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEYS.CLS_EVENT));
  window.localStorage.removeItem(LOCAL_STORAGE_KEYS.CLS_EVENT);

  if (storedClsEvent) {
    dataLayer.push(storedClsEvent);
  }

  trackCumulativeLayoutShift();
};

window.addEventListener('load', () => fireCumulativeLayoutShiftEvent());



// WEBPACK FOOTER //
// ./js/core/monitoring/performance.js